<template>
    <div class="min-h-screen flex items-center justify-center bg-gray-50 dark:bg-gray-900">
      <div class="w-full max-w-md bg-white dark:bg-slate-800 rounded-xl shadow p-6">
        <h1 class="text-2xl font-semibold mb-6 text-gray-900 dark:text-gray-100">Esqueceu sua Senha?</h1>
  
        <form @submit.prevent="inputEmail" class="space-y-4">
          <div>
            <label class="block text-sm mb-1 text-gray-700 dark:text-gray-100">E-mail</label>
            <input v-model.trim="email" type="email" required
                   class="w-full px-3 py-2 border rounded-md dark:bg-slate-800 dark:border-slate-700 dark:text-gray-100"/>
                   <p class="mt-1 text-xs text-gray-500 dark:text-gray-400">
                    Uma senha temporária será enviada para o e-mail informado.
                  </p>
          </div>
  
          <fwb-button gradient="green-blue" outline class="w-full py-2" :disabled="loading">
            {{ loading ? 'Enviando' : 'Enviar' }}
          </fwb-button>
        </form>
        <div class="fixed top-4 right-4 z-50 space-y-2">
            <fwb-toast v-if="toast.success" type="success">Registro enviado com sucesso para o email informado.</fwb-toast>
            <fwb-toast v-if="toast.error" type="danger">{{ toast.errorMessage }}</fwb-toast>
        </div>
        <p class="mt-4 text-sm">
  <router-link to="/login" class="text-emerald-500 hover:underline">Voltar para a tela de login</router-link>
</p>
        <p v-if="error" class="mt-4 text-sm text-red-500">{{ error }}</p>
      </div>
    </div>
    
  </template>
  
  <script>
  import axios from 'axios';
  import { FwbButton, FwbToast } from 'flowbite-vue';
  
  export default {
    components: { FwbButton, FwbToast },
    data() {
      return { 
        email: '', 
        loading: false, 
        error: '', 
        toast: { success: false, error: false, errorMessage: '' },
        apiBase: this.getApiBase()
      };
    },
    methods: {
      getApiBase() {
        if (window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1') {
          return 'http://localhost:5000';
        }
        return '/api';
      },
      async inputEmail() {
        this.loading = true; this.error = '';
        try {

          await axios.post(`${this.apiBase}/change-password`, {
            email: this.email,
          });
          this.toast.success = true;
          const redirect = this.$route.query.redirect || '/login';
          setTimeout(() => this.$router.replace(redirect), 2000);

        } catch (e) {

          this.error = 'Email não encontrado';
          this.toast.error = true;
          console.error(e);
        } finally {
          this.loading = false;
        }
      },
    },
  };
  </script>

